import { render } from "./InventoryType.vue?vue&type=template&id=17b28bb4&scoped=true"
import script from "./InventoryType.vue?vue&type=script&lang=ts"
export * from "./InventoryType.vue?vue&type=script&lang=ts"

import "./InventoryType.vue?vue&type=style&index=0&id=17b28bb4&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-17b28bb4"

export default script